import {
  PensionsItem,
  Data
} from '../../../interfaces/ApolloResponse.interface'

const pensionIsTemporary = (_: Data, item: PensionsItem) => !!item?.isTemporary

export default pensionIsTemporary
